import type { AssetKind, BisAssetRef } from '@raro/domain';
import { createContext, useContext } from 'react';

export type BisAsset = { title: string; kind: AssetKind; url: string | null; thumbUrl: string | null };
/**
 * Os arquivos dos blocos do BIS (logo, ícones, padrões, exemplos). Quem desenha um bloco pergunta aqui pela imagem de um
 * ativo; quem edita sobe um arquivo novo por aqui. Sem o contexto (uma leitura fora da página do BIS), os blocos de
 * arquivo aparecem só com os rótulos.
 */
export const BisAssetsContext = createContext<{ lookup: (id: string) => BisAsset | undefined; upload?: (file: File, kind: AssetKind) => Promise<BisAssetRef> }>({ lookup: () => undefined });
export const useBisAssets = () => useContext(BisAssetsContext);
